import type { ExampleIconAliases } from './icons';

const aliases: ExampleIconAliases = {
  dark: 'fas fa-moon',
  light: 'fas fa-sun',
  lightdark: 'fas fa-adjust',
  ltr: 'fas fa-align-left',
  rtl: 'fas fa-align-right',
  palette: 'fas fa-palette',
  settings: 'fas fa-gear',
  formatText: 'fas fa-text',
  iconFormWrapperShow: 'fas fa-compress',
  iconFormWrapperHide: 'fas fa-expand',
  reload: 'fas fa-rotate-right',
  save: 'fas fa-floppy-disk',
  github: 'fab fa-github',
};

export { aliases };
